import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import "./NavBar.css";

function NavBar() {
    const location = useLocation();
    const isLanding = location.pathname === "/";
    const isHowTo = location.pathname.startsWith("/howto");

    const isLightMenu =
        location.pathname === "/ourmission" ||
        location.pathname === "/explore" ||
        location.pathname.startsWith("/howto") ||
        location.pathname === "/testimonials" ||
        location.pathname === "/privacy";

    const [expanded, setExpanded] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsScrolled(window.scrollY > 50);
        };

        window.addEventListener("scroll", handleScroll);

        handleScroll();

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);

    const handleNavClick = () => {
        setExpanded(false);
    };

    return (
        <Navbar
            expand="md"
            fixed="top"
            expanded={expanded}
            onToggle={(value) => setExpanded(value)}
            className={`pt-3 navbar-glass 
                ${isLanding ? "navbar-glass-landing" : ""} 
                ${isHowTo ? "navbar-glass-howto" : ""}
                ${isLightMenu ? "menu-white" : "menu-black"}
                ${isScrolled ? "navbar-scrolled" : ""}
            `}
            style={{ padding: "0" }}
        >
            <Container
                className={
                    isLanding
                        ? "pb-2"
                        : "border-bottom border-light pb-2"
                }
            >
                <Navbar.Toggle aria-controls="main-nav" />

                <Navbar.Collapse id="main-nav">
                    <Nav className="w-100 justify-content-between text-uppercase fw-bold">

                        <Nav.Link
                            as={Link}
                            to="/"
                            onClick={handleNavClick}
                            className={`nav-link-custom ${
                                location.pathname === "/" ? "active" : ""
                            }`}
                        >
                            Home
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/ourmission"
                            onClick={handleNavClick}
                            className={`nav-link-custom ${
                                location.pathname === "/ourmission" ? "active" : ""
                            }`}
                        >
                            Our Mission
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/explore"
                            onClick={handleNavClick}
                            className={`nav-link-custom ${
                                location.pathname === "/explore" ? "active" : ""
                            }`}
                        >
                            Explore
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/howto"
                            onClick={handleNavClick}
                            className={`nav-link-custom ${
                                location.pathname.startsWith("/howto")
                                    ? "active"
                                    : ""
                            }`}
                        >
                            How To's
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/testimonials"
                            onClick={handleNavClick}
                            className={`nav-link-custom ${
                                location.pathname === "/testimonials"
                                    ? "active"
                                    : ""
                            }`}
                        >
                            Testimonials
                        </Nav.Link>

                        <Nav.Link
                            as={Link}
                            to="/privacy"
                            onClick={handleNavClick}
                            className={`nav-link-custom ${
                                location.pathname === "/privacy" ? "active" : ""
                            }`}
                        >
                            Privacy
                        </Nav.Link>

                    </Nav>
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
}

export default NavBar;